import React, { ReactElement, useState, useEffect } from "react";
import { Translate } from "react-redux-i18n";
import { Grid, TextField, IconButton, InputAdornment, Box, Checkbox, FormControlLabel } from "@mui/material";

import { PayloadData, UserPayloadData } from "redux/wallet/walletSlice";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import styles from "./styles.module.scss";

interface IProps {
  data: PayloadData | UserPayloadData;
  action?: string
  handleChange: (name: string, value: string | boolean, group: string) => void;
  handleChangePassword: (value: boolean) => void,
  change_password?: boolean
}

export default function UserInformation({
  data,
  action,
  handleChange,
  handleChangePassword,
  change_password
}: IProps): ReactElement {
  const [passwordError, setPasswordError] = useState(false);
  const [passwordLengthError, setPasswordLengthError] = useState(false);
  const [values, setVisible] = useState({
    isPasswordVisible: false,
    isCPasswordVisible: false,
  });

  const handleClickShowPassword = () => {
    setVisible({
      ...values,
      isPasswordVisible: !values.isPasswordVisible,
    })
  };
  const handleClickShowCPassword = () => {
    setVisible({
      ...values,
      isCPasswordVisible: !values.isCPasswordVisible,
    })
  };

  useEffect(() => {
    data && data.user && data.user.password !== (data && data.user && data.user.c_password)
      && data.user.c_password !== "" ?
      setPasswordError(true)
      : (data && data.user && data.user.password) === (data && data.user && data.user.c_password) ?
        setPasswordError(false)
        : setPasswordError(false)
  }, [data]);

  useEffect(() => {
    data && data.user && data.user.password && data.user.password.length < 5
      && (data && data.user && data.user.password) !== "" ?
      setPasswordLengthError(true)
      : data && data.user && data.user.password && data.user.password.length >= 5 ?
        setPasswordLengthError(false)
        : setPasswordLengthError(false)
  }, [data.user.password]);

  return (
    <Grid container spacing={1} direction="row"  >
      <Grid item md={12} >
        <Grid container spacing={1} direction="row" >
          <Grid item xs={12} md={12}>
            <TextField
              name="username"
              value={data.user.username}
              id="Username"
              label={<Translate value="userInformation.username" />}
              size="small"
              color="secondary"
              fullWidth
              required
              disabled={action === "edit" ? true : false}
              onChange={(event) => {
                if (event.target.value === "" || /^[a-zA-Z0-9]*$/.test(event.target.value)) {
                  handleChange(
                    event.target.name,
                    event.target.value,
                    "user")
                }
              }}
              inputProps={{
                minLength: action === "register" && "3"
              }}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="password"
              value={data.user.password || ""}
              id="Password"
              label="Password"
              size="small"
              color="secondary"
              type={values.isPasswordVisible ? 'text' : 'password'}
              error={passwordLengthError}
              helperText={passwordLengthError && <Translate value="userInformation.error" />}
              fullWidth
              required={action === "edit" ? false : true}
              onChange={(event) => {
                handleChange(event.target.name, event.target.value, "user")
                if (action === "edit") {
                  if (event.target.value.length > 0) {
                    handleChangePassword(true)
                  } else {
                    handleChangePassword(false)
                  }
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={handleClickShowPassword} size='small'>
                      {!values.isPasswordVisible ?
                        <FontAwesomeIcon type="fas" name="eye" />
                        : <FontAwesomeIcon type="fas" name="eye-slash" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="c_password"
              value={data.user.c_password || ""}
              id="Confirm Password"
              color="secondary"
              label={<Translate value="userInformation.c_password" />}
              size="small"
              type={values.isCPasswordVisible ? 'text' : 'password'}
              error={passwordError}
              helperText={passwordError && "Password Mismatch"}
              fullWidth
              required={action === "edit" ? false : true}
              onChange={(event) => handleChange(event.target.name, event.target.value, "user")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      onClick={handleClickShowCPassword}
                    >
                      {!values.isCPasswordVisible ?
                        <FontAwesomeIcon type="fas" name="eye" />
                        : <FontAwesomeIcon type="fas" name="eye-slash" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <Box>
              <FormControlLabel
                control={<Checkbox
                  // defaultChecked={action === "create" && true}
                  checked={change_password}
                  color="secondary"
                  onChange={() => handleChangePassword(!change_password)}
                  className={styles.checkbox}
                />}
                label={<Translate value="userInformation.requireChangePassword" />}
                className={styles.formLabel}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="firstname"
              value={data.user.firstname}
              id="First Name"
              label={<Translate value="userInformation.firstname" />}
              size="small"
              fullWidth
              required={action === "register" ? true : false}
              color="secondary"
              onChange={(event) => handleChange(event.target.name, event.target.value, "user")}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="lastname"
              value={data.user.lastname}
              id="Last Name"
              label={<Translate value="userInformation.lastname" />}
              size="small"
              color="secondary"
              fullWidth
              required={action === "register" ? true : false}
              onChange={(event) => handleChange(event.target.name, event.target.value, "user")}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="email"
              value={data.user.email}
              id="Email"
              label="Email"
              size="small"
              fullWidth
              color="secondary"
              required={action === "register" && process.env.REACT_APP_EMAIL_REQUIRED === "true" ? true : false}
              onChange={(event) => handleChange(event.target.name, event.target.value, "user")}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="phone"
              value={data.user.phone}
              id="Phone"
              label={<Translate value="userInformation.phone" />}
              size="small"
              fullWidth
              required={action === "register" && process.env.REACT_APP_PHONE_REQUIRED === "true" ? true : false}
              color="secondary"
              onChange={(event) => handleChange(event.target.name, event.target.value, "user")}
              className={[styles.label, "form-label"].join(" ")}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid >
  );
}
